import { render, staticRenderFns } from "./AttributeValueBadge.vue?vue&type=template&id=154531dd&scoped=true"
import script from "./AttributeValueBadge.vue?vue&type=script&lang=js"
export * from "./AttributeValueBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154531dd",
  null
  
)

export default component.exports